<template>
  <div>
    <div class="wrapper" v-show="detailShow">
      <div class="tit_w">
        <span class="acc_w">账号</span><span v-if="sale_extend == 1">VIP等级</span><span class="lv_w" v-else>等级</span><span class="mon_w"><span v-show="type==1||type==2">一口价</span><span v-show="type==3">评估价</span><span v-show="type==4">回收价</span></span><span class="sta_w">状态</span>
      </div>
      <scroll class="content" :data="list" :pullup="true" @pullup="scrollToEnd" :pulldown="true" @pulldown="pulldown" ref="scroll">
        <ul class="ul_w">
          <li class="li_w" v-for="(list,index) in list" @click="handleShow(index)" :key="'list'+index">
            <span class="acc_w">{{list.account}}</span>
            <span class="lv_w">{{list.e_level}}</span>
            <span class="mon_w">{{list.sale_price}}元</span>
            <span class="sta_w">{{formatBuyStatus(list.status)}}</span>
            <i class="icon icon-right"></i>
          </li>
        </ul>
        <div class="noData-bg" v-show="sta==1">
          <span>暂无数据</span>
        </div>
      </scroll>
    </div>
    <div class="two" v-show="!detailShow">
      <headTop head-title='账号详情'>
        <div class="back" slot="private-return" @click="getBack"><i class="icon-arrow_lift"></i></div>
      </headTop>
      <div class="detail-content">
        <ul class="two_ul" v-if="detail">
          <li class="two_li">
            <div class="left_p">
              会员帐号
            </div>
            <div class="right_p">
              {{detail.account}}
            </div>
          </li>
          <template v-if="sale_extend == 1">
            <li class="two_li">
              <div class="left_p">
                VIP等级
              </div>
              <div class="right_p">
                {{Number(detail.vip_level) || 0}}
              </div>
            </li>
            <li class="two_li">
              <div class="left_p">
                电子等级
              </div>
              <div class="right_p">
                {{Number(detail.e_level) || 0}}元
              </div>
            </li>
            <li class="two_li">
              <div class="left_p">
                真人等级
              </div>
              <div class="right_p">
                {{Number(detail.r_level) || 0}}元
              </div>
            </li>
            <li v-if="isShow.levelSalary" class="two_li">
              <div class="left_p">
                电子晋级礼金
              </div>
              <div class="right_p">
                {{Number(detail.e_up_reward) || 0}}元
              </div>
            </li>
            <li v-if="isShow.weekSalary" class="two_li">
              <div class="left_p">
                电子周俸禄
              </div>
              <div class="right_p">
                {{Number(detail.e_week_reward) || 0}}元
              </div>
            </li>
            <li v-if="isShow.monthSalary" class="two_li">
              <div class="left_p">
                电子月俸禄
              </div>
              <div class="right_p">
                {{Number(detail.e_month_reward) || 0}}元
              </div>
            </li>
            <li v-if="isShow.levelSalary" class="two_li">
              <div class="left_p">
                真人晋级礼金
              </div>
              <div class="right_p">
                {{Number(detail.r_up_reward) || 0}}元
              </div>
            </li>
            <li v-if="isShow.monthSalary" class="two_li">
              <div class="left_p">
                真人月俸禄
              </div>
              <div class="right_p">
                {{Number(detail.r_month_reward) || 0}}元
              </div>
            </li>
            <li class="two_li">
              <div class="left_p">
                电子棋牌累计有效投注
              </div>
              <div class="right_p">
                {{Number(detail.e_bet_amount) || 0}}元
              </div>
            </li>
            <li class="two_li">
              <div class="left_p">
                真人累计有效投注
              </div>
              <div class="right_p">
                {{Number(detail.r_bet_amount) || 0}}元
              </div>
            </li>
          </template>
          <template v-else>
            <li class="two_li">
              <div class="left_p">
                等级
              </div>
              <div class="right_p">
                {{Number(detail.e_level)}}
              </div>
            </li>
            <li class="two_li" v-if="isShow.levelSalary">
              <div class="left_p">
                等级礼金
              </div>
              <div class="right_p">
                {{Number(detail.e_up_reward)}}元
              </div>
            </li>
            <li class="two_li" v-if="isShow.weekSalary">
              <div class="left_p">
                周俸禄
              </div>
              <div class="right_p">
                {{Number(detail.e_week_reward)}}元
              </div>
            </li>
            <li class="two_li" v-if="isShow.monthSalary">
              <div class="left_p">
                月俸禄
              </div>
              <div class="right_p">
                {{Number(detail.e_month_reward)}}元
              </div>
            </li>
          </template>
          <li class="two_li">
            <div class="left_p">
              一口价
            </div>
            <div class="right_p">
              {{Number(detail.sale_price)}}元
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              发布时间
            </div>
            <div class="right_p">
              {{detail.created_at*1000 | formatDate}}
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              成交时间
            </div>
            <div class="right_p">
              <span v-if="detail.deal_at==0">-</span>
              <span v-else>{{detail.deal_at*1000 | formatDate}}</span>
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              状态
            </div>
            <div class="right_p">
              {{formatBuyStatus(detail.status)}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import scroll from '@/components/common/scroll/scroll'
  import headTop from '@/components/common/header/head'
  import {formatDate} from '@/common/js/common'
  import { mapState } from 'vuex'
  export default {
    name: 'list',
    data () {
      return {
        detailShow: true,
        detail: [],
        sale_extend: ''
      }
    },
    props: {
      type: {
        type: Number,
        default: 1
      },
      list: {
        type: Array
      },
      sta: {
        type: Number,
        default: 1
      }
    },
    computed: {
      ...mapState(['config_info']),
      isShow() {
        const info = this.config_info ? this.config_info : {}
        const weekSalary = Number(info.week_salary_status) === 1
        const monthSalary = Number(info.month_salary_status) === 1
        const levelSalary = Number(info.finance_salary_status) === 1
        return { weekSalary, monthSalary, levelSalary }
      }
    },
    created () {
      this.sale_extend = localStorage.getItem('sale_extend')
    },
    mounted () {
    },
    methods: {
      // 上拉加载
      scrollToEnd () {
        this.$emit('scrollToEnd')
      },
      // 下拉刷新
      pulldown () {
        this.$emit('pulldown')
      },
      finish () {
        this.$refs.scroll.finishPullDown()
        this.$refs.scroll.finishPullUp()
      },
      formatBuyStatus(status) {
        let ret = ''
        if (this.type === 1) {
          switch (status) {
            case 0:
              ret = '报价待审核'
              break
            case 1:
              ret = '报价同意,订单处理中'
              break
            case 2:
              ret = '报价同意,订单处理中'
              break
            case 3:
              ret = '报价不同意'
              break
            case 4:
              ret = '交易成功'
              break
            case 5:
              ret = '其他人已购买'
              break
            default:
              break
          }
        } else if (this.type === 2) {
          switch (status) {
            case 0:
              ret = '待审核'
              break
            case 1:
              ret = '出售中'
              break
            case 2:
              ret = '审核失败'
              break
            case 3:
              ret = '交易成功'
              break
            case 4:
              ret = '交易关闭'
              break
            default:
              break
          }
        }
        return ret
      },
      handleShow (index) {
        this.detailShow = !this.detailShow
        this.detail = this.list[index]
      },
      getBack () {
        this.detailShow = !this.detailShow
        this.$nextTick(() => {
          this.$refs.scroll.refresh()
        })
      }
    },
    filters: {
      formatDate(time) {
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
    },
    components: {
      scroll,
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  .wrapper
    position fixed
    top 0.9rem
    left 0
    bottom 0
    width 100%
    overflow hidden
    // white-space nowrap
    background-color #fff
    z-index 100
    font-size $fz-t3
    color $c-b3
    .tit_w
      height 0.88rem
      padding-left 0.28rem
      padding-right 0.5rem
      display flex
      align-items center
      border-bottom 1px solid #f4f4f4
      & > span
        text-align center
      .acc_w
        flex 2
        text-align left
      .lv_w
        flex 2
      .mon_w
        flex 3
      .sta_w
        flex 2
    .content
      position fixed
      top 1.80rem
      left 0
      bottom 0
      width 100%
      overflow hidden
      font-size $fz-t3
      color $c-b3
      .ul_w
        // display flex
        // flex-direction column
        min-height 101%
        .li_w
          // flex 1
          display flex
          background-color #ffffff
          height 0.88rem
          border-bottom 1px solid #f4f4f4
          align-items center
          position relative
          padding-left 0.28rem
          padding-right 0.5rem
          word-break break-all
          & > span
            text-align center
          .acc_w
            flex 2
            text-align left
          .lv_w
            flex 2
          .mon_w
            flex 3
          .sta_w
            flex 2
          .icon
            position absolute
            right 0.28rem
            top 0.3rem
            width 0.13rem
            height 0.23rem
            display inline-block
            background-size cover
            &.icon-right
              bg-image('icon-right')
      .noData-bg
        display flex
        flex-direction column
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        & > span
          // padding-top 0.1rem
          font-size $font-size-l
          text-align center
  .two
    .back
      position absolute
      top 0
      left 0
      padding-left 0.2rem
      height 0.9rem
      line-height 0.9rem
      width 0.4rem
      color #fff
      font-size $font-size-m
    .detail-content
      margin-top 0.9rem
      height 100%
      font-size $fz-t3
      color $c-b3
      .two_ul
        .two_li
          display flex
          background-color #fff
          border-bottom 1px solid #f4f4f4
          height 0.88rem
          align-items center
          .left_p
            flex 0 0 2.6rem
            box-sizing border-box
            padding-left 0.28rem
          .right_p
            flex 1
            padding-right 0.28rem
</style>



// WEBPACK FOOTER //
// src/components/record/list.vue